import Cookies from 'js-cookie';
import { kCookieKey } from './constants';

const getters = {
	get tokenExp() {
		const expires = Cookies.get(kCookieKey);
		const expiresStamp = parseInt(expires, 10);

		if (expires && expiresStamp) {
			const millisecsInOneSec = 1000;
			return new Date(expiresStamp * millisecsInOneSec);
		}

		return null;
	},

	get isAuthenticated() {
		return Boolean(getters.tokenExp);
	},
};

export default getters;



// WEBPACK FOOTER //
// ./src/sso-auth/getters.js